 import React from "react";
import { Container, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import { PROJECTS } from "../../Constants";


function Projects() {

  

  return (
    <Container fluid className="project-section" style={{padding:"0px"}} >
      <Container style={{padding:"0px",maxWidth:"100%",minWidth:"100%"}}>
        <h1 className="project-heading " >
           <strong className="purple waviy"   >
            <span>P</span>
            <span>r</span>
            <span>o</span>
            <span>j</span>
            <span>e</span>
            <span>c</span>
            <span>t</span>
            <span style={{color:"#3765ffd8"}} >s</span>
             </strong>
        </h1>
        
        <Container style={{padding:"0px", justifyContent: "center", paddingBottom: "10px",marginTop:"0px" }}>
          {PROJECTS.map((project, index) => (
            <Col md={15} className="project-card" key={index}>
              <ProjectCard
                imgPath1={project.image1}
                imgPath2={project.image2}
                imgPath3={project.image3}
                technologyUsed={project.technologyUsed}
                isBlog={false}
                title={project.name}
                description={project.description}
                link={project.url}
                git={project.git}
                index={index}
              />
            </Col>
          ))}
        </Container>
      </Container>
    </Container>
  );
}

export default Projects;
